import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class DictionaryCreateRequest {
  @jsonMember(String)
  public label!: string;

  @jsonMember(Number)
  public position!: number;

  public constructor(
    private readonly data: {
      label: string;
      position: number;
    },
  ) {
    this.label = this.data.label;
    this.position = this.data.position;
  }
}
